const handleOpenApp = ()=>{
    const isLocal = window.location.hostname.includes("localhost");
    const isDev = window.location.hostname.includes("dev");
    const url = `https://app${(isLocal || isDev)?"-dev":""}.ride-share.app`;
    window.open(url,"_blank");
}
export default handleOpenApp;